import script from "./StudiesGeneralList.vue?vue&type=script&setup=true&lang=js"
export * from "./StudiesGeneralList.vue?vue&type=script&setup=true&lang=js"

import "./StudiesGeneralList.vue?vue&type=style&index=0&id=e9d0f976&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9d0f976"]])

export default __exports__